import { useContext, useState, useMemo, useEffect } from 'react';
import { BIMContext } from 'providers/bim-provider';
import Images from 'assets/Images';
import { useSelector } from 'react-redux';
import { Button, ButtonRow, AutoCompleteInput } from 'components/generic';
import { useFetch } from 'hooks';
import { getValuesById } from 'utils';
import './style.scss';

const TrailFormula = () => {
	const { createObj, setCreateObj, setFormulaIndex, formulaIndex, trailFormulaData } = useContext(BIMContext);
	const [toggleOperatorList, setToggleOperatorList] = useState(false);
	const [toggleTooltip, setToggleTooltip] = useState(false);
	const [selectedOperator, setSelectedOperator] = useState(null);
	const [formulaValue, setFormulaValue] = useState({ bfm_formula: '', bfm_fields: [], bfm_factValues: [] });
	const [searchOperatorList, setSearchOperatorList] = useState([]);
	const api = useFetch();
	const referenceData = useSelector(state => state?.referenceData?.data);

	// input formula from textarea
	const inputformula = e => {
		setFormulaValue(prevState => ({ ...prevState, bfm_formula: e?.replace('@', '') }));
	};

	// calling trialFormula api
	const handleTrailFormulaAPI = async () => {
		await api({ url: 'batchFileMapping/v1/trialFormula', method: 'post', data: formulaValue });

		setCreateObj(prevState => {
			const data = Object.assign({}, prevState);
			data.bfm_uploadDetails[formulaIndex] = { ...data.bfm_uploadDetails[formulaIndex], bfm_formula: formulaValue?.bfm_formula, bfm_fields: formulaValue?.bfm_fields, bfm_factValues: formulaValue?.bfm_factValues };
			return data;
		});
		setFormulaIndex(null);
	};

	// list of serial no in dropdown
	const linkageList = useMemo(() => createObj?.bfm_uploadDetails?.map(el => `'S${el?.bfm_serialNumber}'`), [createObj?.bfm_uploadDetails]);

	// handle select operator
	const handleSelectOperator = e => {
		setFormulaValue(prevState => ({ ...prevState, bfm_formula: prevState.bfm_formula + e }));
	};

	// formula operators
	const operators = getValuesById(referenceData, 'rd_factsOperatorList')[0]?.value;

	//  to show to formula & set formula
	const operatorsList = searchOperatorList?.map((el, i) => (
		<li key={i} onClick={() => setSelectedOperator(el)}>
			{el?.title}
			<img src={Images?.addOperator} onClick={() => handleSelectOperator(el?.id)} alt='+' />
		</li>
	));

	const handleSearch = e => {
		setSearchOperatorList(operators?.filter(el => el?.id?.toLowerCase()?.includes(e?.toLowerCase())));
	};

	useEffect(() => {
		operators?.length && setSearchOperatorList(operators);
	}, [operators]);

	// display all the Use Operators
	const useOperators = (
		<div className='trail-formula__operators'>
			<div className='trail-formula__list'>
				<div className='trail-formula__search'>
					<div className='trail-formula__search--img'>
						<img src={Images?.search} alt='search' />
					</div>
					<input placeholder='Search' onChange={e => handleSearch(e?.target?.value)} />
				</div>
				<ul className='scroll-bar'>{operatorsList}</ul>
			</div>
			{selectedOperator && (
				<div className='trail-formula__display scroll-bar'>
					<h3>{selectedOperator?.title}</h3>
					<span>{selectedOperator?.content}</span>
					<p>Example:</p>
					<code>{selectedOperator?.example}</code>
					<img src={Images?.copyClipboard} alt='copy' onClick={() => displayToolTip(selectedOperator?.example)} />
					{toggleTooltip && <span className='trail-formula__tooltip'>Copied</span>}
				</div>
			)}
		</div>
	);

	// display  ToolTip
	const displayToolTip = e => {
		navigator?.clipboard.writeText(e);
		setToggleTooltip(true); // show tooltip
		setTimeout(() => {
			setToggleTooltip(false); // remove/hide tooltip
		}, 3000);
	};

	// on submit conditions
	const handleSubmit = e => {
		e === 'Goback' && setFormulaIndex(null);
		e === 'Add' && handleTrailFormulaAPI();
	};

	// handle select value from the @ dropdown
	const handleSelectValue = e => {
		const index = e?.indexOf('@') + 1;
		const subset = e?.slice(index);
		const field = subset?.match(/'([^']+)'/)[1];
		const sampleValueIndex = +field?.slice(2) - 1;
		const sampleValue = Object.values(trailFormulaData)[sampleValueIndex];
		setFormulaValue(prevState => ({ ...prevState, bfm_fields: [...prevState.bfm_fields, field], bfm_factValues: [...prevState.bfm_factValues, { type: typeof sampleValue, sample_value: sampleValue, fact_key: field }] }));
	};

	return (
		<div className='trail-formula__add'>
			<AutoCompleteInput options={linkageList} placeholder='Enter a Formula' maxOptions={linkageList?.length} className='trail-formula__text' spacer='' value={formulaValue?.bfm_formula} onSelect={handleSelectValue} onChange={inputformula} />
			<Button label='Use Operators' ghost handleOnSubmit={() => setToggleOperatorList(prevState => !prevState)} />
			{toggleOperatorList && useOperators}
			<ButtonRow label='Goback' label1='Add' right disableSave={!formulaValue?.bfm_formula?.length} handleButtonClick={handleSubmit} />
		</div>
	);
};

export default TrailFormula;
